export default `<svg aria-hidden="true" aria-label="mosaic"  width="24" height="24" viewBox="0 0 24 24" fill="none" >
<g clip-path="url(#clip0_35328_42614)">
<path d="M4 5.77778V18.2222C4 19.2 4.79111 20 5.77778 20H11.1111V4H5.77778C4.79111 4 4 4.8 4 5.77778ZM18.2222 4H12.8889V11.1111H20V5.77778C20 4.8 19.2 4 18.2222 4ZM12.8889 20H18.2222C19.2 20 20 19.2 20 18.2222V12.8889H12.8889V20Z" fill="#111111"/>
</g>
<defs>
<clipPath id="clip0_35328_42614">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>`;
